<template>
  <div class="row">
    <div class="col-12 g">
      <div class="card card-body">
        <div class="d-flex flex-wrap justify-content-between align-items-start logs-head">
          <div>
            <h4 class="mb-25"><i class="fa fa-history"></i> سجل التحركات</h4>
            <p class="text-muted mb-0">تعديل وحذف {{ tab == 'teachers' ? 'المعلمين' : 'الطلاب' }} خلال آخر 30 يوماً، ومن قام بكل إجراء.</p>
          </div>
        </div>

        <div v-if="!owner" class="alert alert-warning mt-1 mb-0 p-1">
          <i class="fa fa-lock"></i> هذه الصفحة لحساب المدرسة فقط.
        </div>

        <template v-else>
          <div class="btn-group mt-1 logs-entity" role="group" aria-label="نوع السجل">
            <button
              v-for="e in entities"
              :key="e.value"
              class="btn"
              :class="tab == e.value ? 'btn-primary' : 'btn-outline-primary'"
              @click="setTab(e.value)"
            ><i :class="e.icon"></i> {{ e.text }}</button>
          </div>

          <div class="d-flex flex-wrap align-items-center mt-1 logs-tools">
            <div class="input-group logs-search">
              <input
                id="students-logs-search"
                v-model.trim="q"
                type="text"
                class="form-control"
                :placeholder="tab == 'teachers' ? 'رقم الهوية أو اسم المعلم أو اسم من قام بالإجراء' : 'رقم الهوية أو اسم الطالب أو اسم من قام بالإجراء'"
                @keyup.enter="search()"
                @input="searchLater()"
              >
              <div class="input-group-append">
                <button class="btn btn-primary" :disabled="loading" @click="search()">
                  <i class="fa fa-search"></i> بحث
                </button>
              </div>
            </div>
            <div class="btn-group logs-chips" role="group" aria-label="نوع الإجراء">
              <button
                v-for="c in chips"
                :key="c.value"
                class="btn btn-sm"
                :class="action == c.value ? 'btn-primary' : 'btn-outline-primary'"
                @click="setAction(c.value)"
              >{{ c.text }}</button>
            </div>
          </div>

          <div v-if="error" class="alert alert-danger mt-1 mb-0 p-1">{{ error }}</div>

          <div class="table-responsive mt-1">
            <table class="table table-sm table-bordered table-hover mb-0">
              <thead>
                <tr>
                  <th>التاريخ والوقت</th>
                  <th>الإجراء</th>
                  <th>{{ tab == 'teachers' ? 'المعلم' : 'الطالب' }}</th>
                  <th>بواسطة</th>
                  <th>التفاصيل</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading && !list.length">
                  <td colspan="5" class="text-center text-muted p-2">جاري التحميل...</td>
                </tr>
                <tr v-else-if="!list.length">
                  <td colspan="5" class="text-center text-muted p-2">
                    {{ q || action ? 'لا توجد نتائج مطابقة للبحث.' : 'لا توجد تعديلات أو عمليات حذف في آخر 30 يوماً.' }}
                  </td>
                </tr>
                <tr v-for="x in list" :key="x._id">
                  <td class="nowrap"><bdi dir="ltr">{{ x.at }}</bdi></td>
                  <td>
                    <span class="badge" :class="x.kind == 'حذف' ? 'badge-danger' : (x.action == 'edit' ? 'badge-warning' : 'badge-info')">{{ x.kind }}</span>
                    <div class="small mt-25">{{ x.title }}</div>
                    <span v-if="x.bulk_count > 1" class="badge badge-light-secondary mt-25">جماعي ({{ x.bulk_count }})</span>
                  </td>
                  <td>
                    <strong>{{ x.name || '—' }}</strong>
                    <div class="small text-muted"><bdi dir="ltr">{{ x.number }}</bdi></div>
                    <div v-if="x.classname" class="small text-muted">{{ x.classname }} - {{ x.classroom }}</div>
                    <div v-if="x.ta5asos" class="small text-muted">{{ x.ta5asos }}</div>
                  </td>
                  <td>
                    {{ x.by }}
                    <div v-if="x.source" class="small text-muted">{{ x.source }}</div>
                  </td>
                  <td class="details">
                    <template v-if="x.after">
                      <div v-for="c in changes(x)" :key="c.key" class="change">
                        <span class="text-muted">{{ c.label }}:</span>
                        <span class="old">{{ c.before }}</span>
                        <i class="fa fa-long-arrow-left"></i>
                        <span class="new">{{ c.after }}</span>
                      </div>
                      <span v-if="!changes(x).length" class="text-muted small">لم تتغير البيانات الظاهرة</span>
                    </template>
                    <template v-else>
                      <div class="small text-muted mb-25">البيانات وقت الحذف:</div>
                      <div v-for="f in snapshot(x.before)" :key="f.key" class="change">
                        <span class="text-muted">{{ f.label }}:</span> {{ f.value }}
                      </div>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="pages > 1" class="d-flex justify-content-center align-items-center mt-1 logs-pager">
            <button class="btn btn-sm btn-outline-primary" :disabled="page <= 1 || loading" @click="go(page - 1)">
              <i class="fa fa-arrow-right"></i> السابق
            </button>
            <span class="text-muted">صفحة {{ page }} من {{ pages }} ({{ total }} إجراء)</span>
            <button class="btn btn-sm btn-outline-primary" :disabled="page >= pages || loading" @click="go(page + 1)">
              التالي <i class="fa fa-arrow-left"></i>
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// students and teachers share this page; keys not present in a row are simply skipped.
var LABELS = {
  name: 'الاسم',
  number: 'رقم الهوية',
  phones: 'الجوال',
  phone: 'الجوال',
  classname: 'الصف',
  classroom: 'الفصل',
  ta5asos: 'التخصص',
  level: 'المرحلة',
  job_number: 'الرقم الوظيفي',
  current_job: 'العمل الحالي',
  degree: 'الدرجة',
  username: 'اسم المستخدم',
  group: 'المجموعة',
};

export default {
  data() {
    var user = null;
    try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch (e) {}
    return {
      user: user,
      // the school's own account only, not a supervisor (مشرف)
      owner: !!user && !user.subuser && !user.admin_id,
      q: '',
      action: '',
      tab: 'students',
      page: 1,
      per: 50,
      total: 0,
      list: [],
      loading: false,
      error: '',
      timer: null,
      chips: [
        { value: '', text: 'الكل' },
        { value: 'edit', text: 'تعديل' },
        { value: 'delete', text: 'حذف' },
      ],
      entities: [
        { value: 'students', text: 'الطلاب', icon: 'fa fa-user' },
        { value: 'teachers', text: 'المعلمين', icon: 'fa fa-user-circle' },
      ],
    };
  },
  computed: {
    pages() {
      return Math.max(1, Math.ceil(this.total / this.per));
    },
  },
  created() {
    if (this.owner) this.load();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    load() {
      var g = this;
      g.loading = true;
      g.error = '';
      $.post(api + '/user/students/logs', {
        jwt: g.user.jwt,
        q: g.q,
        action: g.action,
        type: g.tab,
        page: g.page,
      }).then(function (r) {
        g.loading = false;
        if (r.status != 100) {
          g.error = r.response;
          g.list = [];
          g.total = 0;
          return;
        }
        g.list = r.response.list || [];
        g.total = r.response.total || 0;
        g.per = r.response.per || 50;
      }).fail(function () {
        g.loading = false;
        g.error = 'تعذر الاتصال بالخادم، حاول مرة أخرى.';
      });
    },
    search() {
      clearTimeout(this.timer);
      this.page = 1;
      this.load();
    },
    searchLater() {
      var g = this;
      clearTimeout(g.timer);
      g.timer = setTimeout(function () { g.search(); }, 600);
    },
    setAction(v) {
      this.action = v;
      this.search();
    },
    setTab(v) {
      if (this.tab == v) return;
      this.tab = v;
      this.q = '';
      this.action = '';
      this.page = 1;
      this.list = [];
      this.total = 0;
      this.load();
    },
    go(p) {
      this.page = p;
      this.load();
    },
    text(v) {
      if (Array.isArray(v)) return v.filter(function (x) { return x; }).join('، ') || '—';
      return v === undefined || v === null || v === '' ? '—' : String(v);
    },
    // edits: only the fields that changed, as «الحقل: قبل ← بعد»
    changes(x) {
      var g = this, before = x.before || {}, after = x.after || {}, out = [];
      Object.keys(LABELS).forEach(function (k) {
        if (!(k in before) && !(k in after)) return;
        var b = g.text(before[k]), a = g.text(after[k]);
        if (b !== a) out.push({ key: k, label: LABELS[k], before: b, after: a });
      });
      return out;
    },
    // deletes: what the student looked like
    snapshot(before) {
      var g = this, out = [];
      before = before || {};
      Object.keys(LABELS).forEach(function (k) {
        if (k in before && g.text(before[k]) !== '—') out.push({ key: k, label: LABELS[k], value: g.text(before[k]) });
      });
      return out;
    },
  },
};
</script>

<style scoped>
.logs-tools { gap: 10px; }
.logs-search { max-width: 520px; flex: 1 1 320px; }
.logs-chips .btn { min-width: 70px; }
.logs-pager { gap: 14px; }
.nowrap { white-space: nowrap; }
.details { min-width: 240px; }
.change { font-size: 0.9rem; line-height: 1.7; }
.change .old { color: #ea5455; text-decoration: line-through; }
.change .new { color: #28c76f; font-weight: 600; }
.change .fa { margin: 0 4px; color: #b9b9c3; }
</style>
